// https://formatjs.io/docs/polyfills
// These polyfills must be in this particular order

// We don't require polyfills in our testing environment, though we should add
// coverage at some point to ensure browsers which _do_ are indeed loading them
/* istanbul ignore if */
if (!Intl.getCanonicalLocales) {
  import('@formatjs/intl-getcanonicallocales/polyfill.js');
}

if (!Intl.Locale) {
  import('@formatjs/intl-locale/polyfill.js');
}

if (!Intl.PluralRules) {
  import('@formatjs/intl-pluralrules/polyfill.js');
  import('@formatjs/intl-pluralrules/locale-data/en.js');
  import('@formatjs/intl-pluralrules/locale-data/es.js');
  import('@formatjs/intl-pluralrules/locale-data/fr.js');
  import('@formatjs/intl-pluralrules/locale-data/de.js');
}

if (!Intl.NumberFormat) {
  import('@formatjs/intl-numberformat/polyfill.js');
  import('@formatjs/intl-numberformat/locale-data/en.js');
  import('@formatjs/intl-numberformat/locale-data/es.js');
  import('@formatjs/intl-numberformat/locale-data/fr.js');
  import('@formatjs/intl-numberformat/locale-data/de.js');
}

if (!Intl.RelativeTimeFormat) {
  import('@formatjs/intl-relativetimeformat/polyfill.js');
  import('@formatjs/intl-relativetimeformat/locale-data/en.js');
  import('@formatjs/intl-relativetimeformat/locale-data/es.js');
  import('@formatjs/intl-relativetimeformat/locale-data/fr.js');
  import('@formatjs/intl-relativetimeformat/locale-data/de.js');
}
